import { Modal } from 'react-bootstrap';
import React from 'react';
// import moment from 'moment'
import './modal-attendance-time-picker.component.css'
import '../../assets/css/bootstrap.css'
import moment from 'moment'
import {
  DateTimePicker,
  DatePicker,
  TimePicker,
  MonthPicker,
  InlineDateTimePicker,
  InlineDatePicker,
  InlineTimePicker,
  InlineMonthPicker,
} from "react-tempusdominus-bootstrap";

type MyProps = {
  my_modal_title:string,
  minuteStep:Number,
  getStartTime
  close
}
type MyState = {
  showModal:boolean
  reason:string
  meridian:boolean
  time:any
}
export class ModalAttendanceTimePicker extends React.Component<MyProps,MyState> {

  state:MyState={
    showModal:true,
    reason:" ",
    meridian:true,
    time: moment('10:00 AM').format('LT')
  }

  
  
  constructor(props) { 
    super(props)
    console.log("attendance time picker")
    this.selectTime = this.selectTime.bind(this)
  }

  toggleMeridian() {
    this.state.meridian = !this.state.meridian;
  }

 handleClose(reason:string){
   this.setState({showModal:false,reason:reason})
   this.props.close()
}

  selectTime(){
    console.log('selectTime : '+JSON.stringify(this.state.time));
    // return new Promise(function(resolve,reject){
    //   if(this.state.time)
    //   {
    //     resolve(this.state.time)
    //   }
    //   else
    //   {
    //     reject("No time found")
    //   }

    // })
  this.setState({showModal:false})
  this.props.close()

  this.props.getStartTime(this.state.time)

    //this.viewCtrl.dismiss(this.result);
  }


  render(){
    return(
      <div>
        <Modal show={this.state.showModal}>
          <Modal.Header>
            <Modal.Title><h4 className="modal-title">{this.props.my_modal_title}</h4></Modal.Title>
            <button type="button" className="close" aria-label="Close" onClick={() => this.handleClose("Cross Click")}>
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            {/* <TimePicker minuteStep={this.props.minuteStep} meridian={this.state.meridian} value={this.state.time} onChange={(e) => {this.setState({time:e.target.value})}}></TimePicker>
             */}
              {/* <div className="input-group-append" data-target="#datetimepicker3" data-toggle="datetimepicker"></div>
               */}
                <InlineTimePicker  onChange={(e) => {
                  console.log(e.date.format("HH:mm"))
                  this.setState({time:e.date.format("HH:mm")})}
                  }
                  
                  onUpdate={e => {
                    console.log(
                      "onUpdate",
                      e.change,
                      e.viewDate,
                      e.viewDate.format("HH:mm"),
                      e
                    );
                  }}/>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-outline-success" onClick={() => this.selectTime()}>
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </div>
     
   
    );
  }

}
